import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Users, Search, CalendarClock, CalendarDays, MessageSquare, CheckSquare, BarChart2, Settings, User, LogOut } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
export function SideNav() {
  const {
    user,
    logout
  } = useAuth();
  const navigate = useNavigate();
  const navItems = [{
    to: '/app/dashboard',
    icon: LayoutDashboard,
    label: 'Dashboard'
  }, {
    to: '/app/leads',
    icon: Users,
    label: 'Leads'
  }, {
    to: '/app/enriquecimiento',
    icon: Search,
    label: 'Enriquecimiento'
  }, {
    to: '/app/calendario',
    icon: CalendarDays,
    label: 'Calendario'
  }, {
    to: '/app/cadencias',
    icon: CalendarClock,
    label: 'Cadencias'
  }, {
    to: '/app/campanas',
    icon: MessageSquare,
    label: 'Campañas'
  }, {
    to: '/app/qa',
    icon: CheckSquare,
    label: 'QA'
  }, {
    to: '/app/reportes',
    icon: BarChart2,
    label: 'Reportes'
  }, {
    to: '/app/config',
    icon: Settings,
    label: 'Configuración'
  }];
  const handleLogout = async () => {
    await logout();
    navigate('/login', {
      replace: true
    });
  };
  return <aside className="hidden md:flex fixed left-0 top-0 h-screen w-[260px] flex-col bg-growthly-surface border-r border-white/[0.04] z-30" data-id="element-257">
      <div className="px-6 py-5 border-b border-white/[0.04]" data-id="element-258">
        <h1 className="text-[20px] font-bold text-white" data-id="element-259">Growthly</h1>
        <p className="text-[11px] text-growthly-muted mt-0.5" data-id="element-260">CRM Setter</p>
      </div>

      <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto" data-id="element-261">
        {navItems.map(({
        to,
        icon: Icon,
        label
      }) => <NavLink key={to} to={to} className={({
        isActive
      }) => `flex items-center gap-3 px-3 h-10 rounded-lg text-[14px] transition-colors ${isActive ? 'bg-white text-[#0B0B0B] font-medium' : 'text-growthly-text-2 hover:bg-white/[0.03] hover:text-white'}`} data-id="element-262">
            <Icon size={18} strokeWidth={1.8} data-id="element-263" />
            {label}
          </NavLink>)}
      </nav>

      <div className="p-3 border-t border-white/[0.04]" data-id="element-264">
        <div className="flex items-center gap-3 px-3 py-2 rounded-lg bg-white/[0.02]" data-id="element-265">
          <div className="w-9 h-9 rounded-full bg-white/[0.05] flex items-center justify-center text-white" data-id="element-266">
            <User size={16} strokeWidth={1.8} data-id="element-267" />
          </div>
          <div className="flex-1 min-w-0" data-id="element-268">
            <p className="text-[13px] font-medium text-white truncate" data-id="element-269">
              {user?.name ?? 'Sin perfil'}
            </p>
            <p className="text-[11px] text-growthly-muted truncate" data-id="element-270">
              {user?.email ?? '—'}
            </p>
          </div>
          <button onClick={handleLogout} aria-label="Cerrar sesión" className="w-8 h-8 rounded-md flex items-center justify-center text-growthly-muted hover:text-white hover:bg-white/[0.05] transition-colors" data-id="element-271">
            <LogOut size={15} strokeWidth={1.8} data-id="element-272" />
          </button>
        </div>
      </div>
    </aside>;
}